import { WidgetType } from '@lastbrand/storefront-proto-registry/api/v1/enums'

import { PLBaseErrorBoundary } from '@src/components/pl-base-error-boundary'
import { PLTypedWidgetInterface, PLTypedWidgetProps } from '@src/components/pl-base-widget'

import type { HtmlWidgetData } from '@lastbrand/storefront-proto-registry/api/v1/widget'

/**
 * HTML widget — registered sentinel for the ACCORDION's nested HTML children (v2 PDP). The parent
 * ACCORDION reads their raw `data.htmlData` directly and renders them as accordion rows, so a standalone
 * HTML widget renders nothing here; this registration exists only to suppress the dev "unknown widget
 * type" warning for the nested children.
 */
function HtmlWidgetComponent(_props: PLTypedWidgetProps<HtmlWidgetData>) {
  return null
}

export const HtmlWidget: PLTypedWidgetInterface<HtmlWidgetData, WidgetType.HTML> = {
  id: WidgetType.HTML,
  errorBoundary: PLBaseErrorBoundary,
  render: HtmlWidgetComponent,
}
